import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { CorpException } from '@corporate-tailwind/model';
import { CorpExceptionManager } from '@corporate-tailwind/error-page';
import { Router } from '@angular/router';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private _corpExceptionManager = inject(CorpExceptionManager);
  private _router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //  console.log('Interceptor HIT', req.url);
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {

          const corpError: CorpException = this._corpExceptionManager.mapToCorpException(error);
          // 👉 Ici tu peux logger globalement si besoin
          // console.error('CorpException intercepted:', corpError);

        // 👉 Redirection sur erreur 500
        if (error.status === 500) {
          this._router.navigate(['/500']); // adapte la route
        }

          return throwError(() => corpError);
        })
      );
    }

}